"use client"

import { BeerOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BeerOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BeerOffIcon = component(Icon)({ as: BeerOff })
